export const formatDuration = (language: string, seconds?: number,) => {
  const isEnglish = language.startsWith("en");
  if (!seconds || seconds <= 0) {
    return isEnglish ? "0 min" : "0 dk";
  }

  const totalMinutes = Math.floor(seconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const remainingSeconds = Math.round(seconds % 60);
  const parts: string[] = [];

  if (hours > 0) {
    parts.push(`${hours} ${isEnglish ? "h" : "sa"}`);
  }

  if (minutes > 0) {
    parts.push(`${minutes} ${isEnglish ? "min" : "dk"}`);
  }

  if (parts.length === 0 && remainingSeconds > 0) {
    parts.push(`${remainingSeconds} ${isEnglish ? "sec" : "sn"}`);
  }

  return parts.join(" ");
};